import script from "./AddInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./AddInvoice.vue?vue&type=style&index=0&id=a64794d4&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a64794d4"]])

export default __exports__